import { objectToQuery } from '@mx/util/object-to-query';
import { env, bridge } from './index';

export function bindCard(extDimStatEntry: string, callback = () => {}) {
  const params = {
    merchant_no: env.merchantNo,
    callback_type: 'close_webview',
    ext_dim_stat_entry: extDimStatEntry,
    no_credit: 1,
  };
  // 这是线上host https://npay.meituan.com
  const host = `${window.location.protocol}//${window.location.host}`;
  const path = '/portal/bindcard/bindcard.html';
  const url = `${host}${path}?${objectToQuery(params)}`;
  bridge.openPage(url, 0, callback);
  const bindTime = Date.now();
  bridge.setStorage('pay-bindcard-open-time', `${bindTime}`);
}
